import { c as _c } from "react/compiler-runtime";
import { ChangePasswordView } from "@repo/ui/components/profile/ChangePasswordView";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { authClient } from "@/clients/authClient";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_app/mitt-konto/andra-losenord")({
  component: ChangePasswordPage
});
function ChangePasswordPage() {
  const $ = _c(2);
  const navigate = useNavigate();
  let t0;
  if ($[0] !== navigate) {
    t0 = /*#__PURE__*/_jsx(ChangePasswordView, {
      authClient: authClient,
      onSuccess: () => navigate({
        to: "/mitt-konto"
      }),
      onBack: () => navigate({
        to: "/mitt-konto"
      })
    });
    $[0] = navigate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}